export enum RootIndexActionTypes {
  SET_LIST_USER = 'SET_LIST_USER',
}
